import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "../../Components/Header";
import {
  defaultImg,
  fileupload,
  leftArrow,
  tableEye,
} from "../../common/Assets/imgs";
import { useLocation, useNavigate } from "react-router-dom";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import toast from "react-hot-toast";
import { FaEye } from "react-icons/fa";
import { Modal } from "react-bootstrap";

const AddDriverTransport = () => {
  const navigation = useNavigate();
  const [image, setImage] = useState(null);
  //    const [isEdit,setIsEdit]=useState(false);
  // const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(true);

  const [driverDataState, setDriverDataState] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const location = useLocation();
  console.log("location", location);
  const { type, datas, data } = location.state || {};
  const [adminList, setAdminList] = useState([]);
  console.log("datasdatas", data);

  const fileRefs = useRef({});
  const [viewerFile, setViewerFile] = useState("");
  const [viewerOpen, setViewerOpen] = useState(false);
  const [mode, setMode] = useState("add"); // 'add' | 'view' | 'edit'
  const [driverType, setDriverType] = useState(null);
  const [errorFields, setErrorFields] = useState(new Set());

  const openFileViewer = (fileUrl) => {
    setViewerFile(fileUrl);
    setViewerOpen(true);
  };

  // Remove unused form state, use only formData
  const [formData, setFormData] = useState({
    name: "",
    driver_code: "",
    mobile: "",
    licence_no: "",
    licence_type: "",
    licence: "",
    id_proof: "",
    address_proof: "",
    transport_licence: "",
  });

  // ✅ Set mode from location.state (priority) or sessionStorage fallback
  useEffect(() => {
    const { type, datas, data } = location.state || {};
    let determinedMode = type || "add";

    if (type === "add") {
      // Clear sessionStorage for fresh add
      sessionStorage.removeItem("driverdata");
      sessionStorage.removeItem("drivertype");
    } else {
      // Load from sessionStorage if no location.state
      try {
        const storedData = sessionStorage.getItem("driverdata");
        const storedType = sessionStorage.getItem("drivertype");
        if (storedData) {
          setDriverDataState(JSON.parse(storedData));
        }
        if (storedType && !type) {
          determinedMode = storedType;
          setDriverType(storedType);
        }
      } catch (error) {
        console.error("Failed to parse sessionStorage:", error);
      }
    }

    setMode(determinedMode);
    console.log("Determined mode:", determinedMode, "location type:", type);
  }, [location.state]);

  const tabs = [
    { name: "Driver Details", path: "/adddrivers-transport" },
    { name: "Driver Trip History", path: "/drivers-triphistory" },
  ];
  const removeImage = () => {
    setImage(null);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage({
        file,
        preview: URL.createObjectURL(file),
      });
    }
  };

  // ✅ Fixed duplicate formData - only one declaration

  // ✅ Handle File Change (Same as your TransportView)
  const handleFileChange = (e, id, name) => {
    const file = e.target.files[0];

    if (file) {
      setUploadedFiles((prev) => ({
        ...prev,
        [id]: file.name,
      }));

      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
    }
  };

  // Validation function
  // const validateForm = () => {
  //   const errors = {};

  //   // Check transport_id
  //   const transportId = localStorage.getItem("transport_id");
  //   if (!transportId) {
  //     errors.transport_id = "Please select a transport";
  //   }

  //   // Validate text fields
  //   vehicleFields.forEach((field) => {
  //     if (!field.fileupload) {
  //       const value = formData[field.name]?.trim();

  //       if (!value) {
  //         errors[field.name] = `${field.label} is required`;
  //       }
  //       else if (field.name === "mobile" && !/^\d{10}$/.test(value)) {
  //         errors[field.name] = "Mobile number must be exactly 10 digits";
  //       }
  //       else if (field.name === "licence_no" && value.length > 16) {
  //         errors[field.name] = "License No must be 16 characters or less";
  //       }
  //     }
  //   });

  //   // Validate file uploads
  //   vehicleFields.forEach((field) => {
  //     if (field.fileupload) {
  //       const isFileUploaded = formData[field.name] instanceof File;
  //       const hasExistingFile = mode !== "add" && driverDataState?.[field.value];

  //       if (!isFileUploaded && !hasExistingFile) {
  //         errors[field.name] = `${field.label} is required`;
  //       }
  //     }
  //   });

  //   // 🔔 Show toast for each error
  //   if (Object.keys(errors).length > 0) {
  //     Object.values(errors).forEach((msg) => {
  //       toast.error(msg);
  //     });
  //   }

  //   return errors;
  // };

  const validateForm = () => {
    const invalidFields = new Set();

    // Transport ID
    const transportId = localStorage.getItem("transport_id");
    if (!transportId) {
      invalidFields.add("transport_id");
      return {
        error: "Please select a transport",
        invalidFields,
      };
    }

    // Loop fields
    for (let field of vehicleFields) {
      if (!field.fileupload) {
        const value = formData[field.name]?.trim();

        if (!value) {
          invalidFields.add(field.name);
          return {
            error: `${field.label} is required`,
            invalidFields,
          };
        }

        if (field.name === "mobile" && !/^\d{10}$/.test(value)) {
          invalidFields.add(field.name);
          return {
            error: "Mobile number must be exactly 10 digits",
            invalidFields,
          };
        }

        if (field.name === "licence_no" && value.length > 16) {
          invalidFields.add(field.name);
          return {
            error: "License No must be 16 characters or less",
            invalidFields,
          };
        }
      }
    }

    return { error: null, invalidFields };
  };

  const vehicleFields = [
    { id: 1, name: "name", label: "Driver Name", fileupload: false },
    {
      id: 2,
      name: "mobile",
      label: "Mobile Number",
      fileupload: false,
      maxLength: 10,
    },
    {
      id: 3,
      name: "licence_no",
      label: "License No",
      fileupload: false,
      maxLength: 16,
    },
    { id: 4, name: "licence_type", label: "License Type", fileupload: false },

    {
      id: 5,
      name: "licence",
      label: "Driver License",
      fileupload: true,
      value: "licence_url",
    },
    {
      id: 6,
      name: "id_proof",
      label: "Driver ID Proof",
      fileupload: true,
      value: "id_proof_url",
    },
    {
      id: 7,
      name: "address_proof",
      label: "Address Proof",
      fileupload: true,
      value: "address_proof_url",
    },
    {
      id: 8,
      name: "transport_licence",
      label: "Transport Licence",
      fileupload: true,
      value: "transport_licence_url",
    },
  ];

  // const handleSave = async () => {
  //   try {
  //     setLoader(true);

  //     const { errors, invalidFields } = validateForm();
  //     setErrorFields(invalidFields);
  //     if (errors.length > 0) {
  //       toast.error(errors.join(', '));
  //       setLoader(false);
  //       return;
  //     }
  //     setErrorFields(new Set());

  //     const payload = new FormData();
  //     const transportId = localStorage.getItem("transport_id");
  //     payload.append("transport_id", transportId);

  //     payload.append("name", formData?.name);
  //     payload.append("licence_no", formData?.licence_no);
  //     payload.append("licence_type", formData?.licence_type);
  //     payload.append("mobile", formData?.mobile);

  //     if (formData?.licence instanceof File) {
  //       payload.append("licence", formData.licence);
  //     }

  //     if (formData?.id_proof instanceof File) {
  //       payload.append("id_proof", formData.id_proof);
  //     }

  //     if (formData?.address_proof instanceof File) {
  //       payload.append("address_proof", formData.address_proof);
  //     }

  //     if (formData?.transport_licence instanceof File) {
  //       payload.append("transport_licence", formData.transport_licence);
  //     }

  //     // ✅ Append vehicle image if selected
  //     if (image?.file) {
  //       payload.append("image", image.file);
  //     }

  //     payload.append("transport", datas?.id || driverDataState?.id);

  //     console.log("payload", payload);

  //     // ========================
  //     // ✅ ADD
  //     // ========================
  //     if (mode === "add") {
  //       const res = await post(URLS.VEHICLE_DRIVER_ADD, payload);

  //       if (res?.status === "success") {
  //         toast.success(res?.message || "Driver Added Successfully");
  //         navigation(-1);
  //       }
  //     } else {
  //       const res = await put(
  //         `${URLS.VEHICLE_DRIVER_EDIT}${driverDataState?.id}/`,
  //         payload,
  //       );

  //       if (res?.status === "success") {
  //         toast.success(res?.message || "Driver Updated Successfully");
  //         setIsEditing(false);
  //         navigation(-1);
  //       }
  //     }
  //   } catch (err) {
  //     console.log("err", err);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  const handleSave = async () => {
    try {
      setIsLoading(true);

      const { error, invalidFields } = validateForm();
      setErrorFields(invalidFields);

      if (error) {
        toast.error(error); // 👈 Only ONE error
        setIsLoading(false);
        return;
      }

      setErrorFields(new Set());

      const payload = new FormData();
      const transportId = localStorage.getItem("transport_id");
      // payload.append("transport_id", transportId);

      payload.append("name", formData?.name);
      payload.append("licence_no", formData?.licence_no);
      payload.append("licence_type", formData?.licence_type);
      payload.append("mobile", formData?.mobile);

      if (formData?.licence instanceof File) {
        payload.append("licence", formData.licence);
      }

      if (formData?.id_proof instanceof File) {
        payload.append("id_proof", formData.id_proof);
      }

      if (formData?.address_proof instanceof File) {
        payload.append("address_proof", formData.address_proof);
      }

      if (formData?.transport_licence instanceof File) {
        payload.append("transport_licence", formData.transport_licence);
      }

      if (image?.file) {
        payload.append("image", image.file);
      }

      // payload.append("transport_id", datas?.id || driverDataState?.id);
      payload.append("transport", datas?.id || driverDataState?.id);

      if (mode === "add") {
        const res = await post(URLS.VEHICLE_DRIVER_ADD, payload);

        if (res?.status === "success") {
          toast.success(res?.message || "Driver Added Successfully");
          navigation(-1);
        }
      } else {
        const res = await put(
          `${URLS.VEHICLE_DRIVER_EDIT}${driverDataState?.id}/`,
          payload,
        );

        if (res?.status === "success") {
          toast.success(res?.message || "Driver Updated Successfully");
          // setIsEditing(false);
          navigation(-1);
        }
      }
    } catch (err) {
      console.log("err", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTabClick = (tab) => {
    navigation(tab.path, { state: { datas, type } });
  };

  const getList = useCallback(async () => {
    if (!driverDataState?.id) return;
    try {
      const response = await get(
        `${URLS.VEHICLE_TRANSPORT_DRIVER_LIST}${driverDataState.id}/`,
      );
      console.log("res", response);
      setAdminList(response?.data);
    } catch (error) {
      console.log("err", error);
    }
  }, [driverDataState?.id]);

  useEffect(() => {
    getList();
  }, [getList]);

  // ✅ Populate formData ONLY for view/edit modes, using correct driver fields
  useEffect(() => {
    if (driverDataState && (mode === "view" || mode === "edit")) {
      setFormData({
        name: driverDataState?.name || "",
        driver_code: driverDataState?.driver_code || "",
        mobile: driverDataState?.mobile || "",
        licence_no: driverDataState?.licence_no || "",
        licence_type: driverDataState?.licence_type || "",
        licence: driverDataState?.licence_url || "", // URL for display
        id_proof: driverDataState?.id_proof_url || "",
        address_proof: driverDataState?.address_proof_url || "",
        transport_licence: driverDataState?.transport_licence_url || "",
      });

      // Set image preview for view/edit
      if (driverDataState?.image_url) {
        setImage({
          file: null,
          preview: driverDataState?.image_url,
        });
      }
    } else if (mode === "add") {
      // Reset form for add
      setFormData({
        name: "",
        driver_code: "",
        mobile: "",
        licence_no: "",
        licence_type: "",
        licence: "",
        id_proof: "",
        address_proof: "",
        transport_licence: "",
      });
      setImage(null);
    }

    // Set editing state based on mode
    setIsEditing(mode !== "view");
  }, [mode, driverDataState]);

  return (
    <>
      <Header />

      <div style={{ marginTop: "6rem", padding: "15px" }}>
        <div className="section">
          <h3 onClick={() => navigation(-1)} className="section-titlez">
            <img
              src={leftArrow}
              style={{ marginRight: 10 }}
              className="back-icon-arrow"
              alt=""
            />
            Drivers
          </h3>
          {/* Tabs */}
          {type === "view" && (
            <div className="tabs mb-4 ms-3">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  onClick={() => handleTabClick(tab)}
                  className={`tab-btn ${
                    location.pathname === tab.path ? "active" : ""
                  }`}
                >
                  {tab.name}
                </button>
              ))}
            </div>
          )}

          <div className="form-groupz">
            <label>Driver Images</label>
          </div>

          <div className="image-list">
            {image ? (
              <div className="image-card">
                <img
                  className="imageSize"
                  disabled={!isEditing}
                  src={image.preview}
                  alt="vehicle"
                />
                {isEditing && (
                  <button className="remove-btn" onClick={removeImage}>
                    ×
                  </button>
                )}
              </div>
            ) : (
              <label className="upload-box">
                <img
                  style={{ zIndex: "1" }}
                  src={defaultImg}
                  className="imageSize"
                  alt="vehicle"
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  hidden
                  disabled={!isEditing}
                />
              </label>
            )}
          </div>

          {/* FORM GRID */}
          <div className="form-grid">
            {vehicleFields.map((item) => {
              const uniqueId = `vehicle-${item.id}`;

              // const currentFileValue =item?.value?data?.[item?.value]??'':
              //   uploadedFiles[uniqueId] ||
              //   (formData[item.name] instanceof File
              //     ? formData[item.name].name
              //     : formData[item.name] || "");

              // const currentFileValue =
              //   uploadedFiles[uniqueId] ||
              //   (formData[item.name] instanceof File
              //     ? formData[item.name].name
              //     : item?.value
              //       ? (driverDataState?.[item?.value] ?? "")
              //       : formData[item.name] || "");

              //  const currentFileValue =
              //   uploadedFiles[uniqueId] || formData[item.name]
              //     ? `${item.label} `
              //     : "";

              const fileValue =
                uploadedFiles[uniqueId] ||
                (formData[item.name] ? item.label : "");

              const normalValue = formData[item.name] || "";

              const viewerUrl =
                (typeof formData[item.name] === "string" &&
                  formData[item.name]) ||
                (item?.value ? (driverDataState?.[item?.value] ?? "") : "");

              console.log(
                "testing value",
                // currentFileValue,
                formData[item.name],
                formData,
              );

              return (
                <div className={`form-groupz`}>
                  <label>{item.label}</label>

                  {item.fileupload ? (
                    <div
                      className="upload-boxz"
                      onClick={() => {
                        if (isEditing) {
                          document.getElementById(`file-${uniqueId}`).click();
                        }
                      }}
                      style={{ cursor: !isEditing ? "pointer" : "default" }}
                    >
                      <input
                        type="text"
                        placeholder={`Upload ${item.label}`}
                        value={fileValue}
                        // value={currentFileValue}
                        readOnly
                        disabled={!isEditing}
                      />

                      <input
                        type="file"
                        id={`file-${uniqueId}`}
                        onChange={(e) =>
                          handleFileChange(e, uniqueId, item.name)
                        }
                        style={{ display: "none" }}
                        ref={(el) => {
                          fileRefs.current[uniqueId] = el;
                        }}
                        disabled={!isEditing}
                      />

                      {isEditing ? (
                        <img
                          src={fileupload}
                          alt="upload"
                          className="uploadIcon"
                          onClick={(e) => {
                            e.stopPropagation();
                            fileRefs.current[uniqueId]?.click();
                          }}
                        />
                      ) : (
                        viewerUrl && (
                          <FaEye
                            className="viewIcon"
                            style={{
                              cursor: "pointer",
                              fontSize: "18px",
                              marginRight: 10,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              openFileViewer(viewerUrl);
                            }}
                          />
                        )
                      )}
                    </div>
                  ) : item.dropdown ? (
                    <select
                      className="fileinput"
                      value={formData[item.name] || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          [item.name]: e.target.value,
                        })
                      }
                      disabled={!isEditing}
                    >
                      <option value="">Select {item.label}</option>
                      {adminList?.map((listItem) => (
                        <option key={listItem?.id} value={listItem?.id}>
                          {listItem?.type}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      placeholder={`Enter ${item.label}`}
                      className="fileinput"
                      // value={currentFileValue || ""}
                      value={normalValue}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          [item.name]: e.target.value,
                        })
                      }
                      readOnly={!isEditing}
                      maxLength={item?.maxLength || null}
                    />
                  )}
                </div>
              );
            })}
          </div>

          {/* ACTION BUTTONS */}
          {/* {(mode === "add" || mode === "edit") && (
            <div className="actions">
              <button
                className="save-btn"
                onClick={() => handleSave()}
                disabled={loader}
              >
                {loader ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : mode === "add" ? "Add Driver" : "Update Driver"}
              </button>
              {mode === "view" && (
                <button
                  onClick={() => setIsEditing(!isEditing)}
                  className="edit-btn"
                >
                  {isEditing ? "Cancel" : "Edit"}
                </button>
              )}
            </div>
          )}
         
            <div className="actions">
               {mode === "view" && isEditing && (
              <button
                onClick={() => handleSave()}
                className="save-btn"
                disabled={loader}
              >
                {loader ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : "Save"}
              </button>
              )}
            </div> */}

          <div className="actions">
            {/* VIEW MODE → Show Edit button */}
            {mode === "view" && !isEditing && (
              <button onClick={() => setIsEditing(true)} className="edit-btn">
                Edit
              </button>
            )}

            {/* ADD MODE */}
            {mode === "add" && (
              <button
                className="save-btn"
                onClick={handleSave}
                // disabled={loader}
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  "Add Driver"
                )}
              </button>
            )}

            {/* EDIT MODE OR VIEW→EDIT */}
            {(mode === "edit" || (mode === "view" && isEditing)) && (
              <button
                className="save-btn"
                onClick={handleSave}
                // disabled={loader}
              >
                {/* {loader ? "Loading..." : "Save"} */}
                    {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  "Save"
                )}
              </button>
            )}
          </div>

          <Modal
            show={viewerOpen}
            onHide={() => setViewerOpen(false)}
            centered
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>Document Viewer</Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ height: "80vh" }}>
              {viewerFile?.toLowerCase().endsWith(".pdf") ? (
                <iframe
                  src={`${viewerFile}#toolbar=0`}
                  title="PDF Viewer"
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                />
              ) : (
                <img
                  src={viewerFile}
                  alt="Document"
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
              )}
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default AddDriverTransport;
